import { CompanyUser } from "../models/company.user.model";
import api from "../lib/api";
import { TableApiRes } from "../models/base.model";
import { deleteConfirmDialog } from "./common.action";

export async function getCompanyUsers(): Promise<TableApiRes<CompanyUser>> {
  const data = (
    await api<{ users: CompanyUser[] }>({
      url: `/company-users`,
    })
  ).users;
  return { data, total: data.length };
}

export async function addCompanyUser(param: CompanyUser): Promise<CompanyUser> {
  const data = (
    await api<{ user: CompanyUser }>({
      url: `/company-users`,
      data: param,
      method: "POST",
    })
  ).user;
  return data;
}

export async function updateCompanyUser(param: Partial<CompanyUser>) {
  const data = (
    await api<{ user: CompanyUser }>({
      url: `/company-users/${param.username}`,
      data: param,
      method: "PATCH",
    })
  ).user;
  return data;
}

export async function resetCompanyUserPassword(params: { username: string; password: string; companyId: string }) {
  return await api({
    url: `/company-users/reset-password`,
    data: params,
    method: "POST",
  });
}

export async function deleteCompanyUser(id: string, companyId: string) {
  await deleteConfirmDialog(() =>
    api({
      url: `/company-users/${id}`,
      data: {
        sk: companyId,
      },
      method: "DELETE",
    }),
  );
}
